import { Helmet } from 'react-helmet';

import { useOrganisationQuery } from 'graphql/types';

interface IProps {
    children: string;
}

export const PageTitle = ({ children: title }: IProps) => {
    const { data: organisationData } = useOrganisationQuery();

    if (!title) return null;

    const { name: orgName } = organisationData?.organisation || {};

    return (
        <Helmet>
            <title>
                {title}
                {orgName ? ` - ${orgName}` : ''}
            </title>
        </Helmet>
    );
};
